const units = ['B', 'KB', 'MB', 'GB'];

export const formatBytes = (bytes: number) => {
  const rawUnit = bytes === 0 ? 0 : Math.floor(Math.log(bytes) / Math.log(1024));
  const unit = Math.max(0, Math.min(units.length - 1, rawUnit));
  const count = bytes / Math.pow(1024, unit);
  return `${count.toFixed(1)} ${units[unit]}`;
};

/**
 * Convert Celsius to Fahrenheit
 */
export const celsiusToFahrenheit = (celsius: number): number => Math.round((celsius * 9) / 5 + 32);

/**
 * Format temperature with both Fahrenheit and Celsius
 */
export const formatTemperature = (celsius: number): string => {
  const fahrenheit = celsiusToFahrenheit(celsius);
  return `${fahrenheit}°F (${celsius}°C)`;
};
